// import React from 'react';
// import{ROLES}from '../../cmps/../services/user.service'
// export function ProgressCalculator({customHeight, meta, ejecucion, filescount, userRol }) {
//     const isEditable = userRol === ROLES.ADMIN

//     const calculateProgress = (meta, ejecucion) => {
//         if (!meta || meta === 0) return 0;
//         return Math.round((ejecucion / meta) * 100); // Redondea el resultado al número entero más cercano
//     };

//     const progress = calculateProgress(meta, ejecucion);
    

//     return (
        
//         <div className="task-title picker flex align-center space-between" style={{ width: "10px", height:customHeight}}>
            

//                         <blockquote 
//                              contentEditable={isEditable}
//                             // onBlur={(ev) => handleInputChange(ev, 'medio_verificacion')}
//                             suppressContentEditableWarning={true}
//                             style={{ marginLeft: "50px", width: "20px", textAlign:'center',cursor: isEditable ? 'pointer' : 'not-allowed' }}
//                         >
//                             <span style={{textAlign:'center'}}>{progress}%</span>
//                         </blockquote>
//         </div>

        


//     );
// }





//Version de pruebas 

import React from 'react';
import { ROLES } from '../../cmps/../services/user.service';

export function ProgressCalculator({ customHeight, meta, ejecucion, filescount, statustask, userRol }) {
    const isEditable = userRol === ROLES.ADMIN;


    // Nueva función para calcular progreso
    const calculateProgress = (meta, ejecucion, filescount) => {
        if (!meta || meta === 0 || !filescount || filescount.length === 0) return 0;

        // Conteo de archivos con estado_verificable igual a "Aprobado"
        const approvedFilesCount = filescount.filter(file => file.estado_verificable?.toLowerCase() === "aprobado").length;
        


        // Cálculo de valor1 (ejecución entre total de archivos)
        const valor1 = ejecucion / filescount.length;

        
        const multiplicacion = valor1 * approvedFilesCount;



        // Resultado final: valor1 entre ejecución por 100
        return Math.round((multiplicacion / meta) * 100); // Redondeo al número entero más cercano
    };

    // const progress = calculateProgress(meta, ejecucion, filescount); //Version original sin la validacion del estado de la actividad

    const progress = statustask === 4 ? 0 : calculateProgress(meta, ejecucion, filescount); //Version nueva con la modificacion del estado de la actividad



    return (
        <div
            className="task-title picker flex align-center space-between"
            style={{ width: "10px", height: customHeight }}
        >
            <blockquote
                contentEditable={isEditable}
                suppressContentEditableWarning={true}
                style={{
                    marginLeft: "50px",
                    width: "20px",
                    textAlign: 'center',
                    cursor: isEditable ? 'pointer' : 'not-allowed',
                }}
            >
                <span style={{ textAlign: 'center' }}>{progress}%</span>
            </blockquote>
        </div>
    );
}

